import React from 'react';

type SocialLoginProvider = 'apple' | 'facebook' | 'google' | 'microsoft';

interface SocialLoginButtonsProps {
  onSocialLogin: (provider: SocialLoginProvider) => void;
}

const SocialLoginButtons: React.FC<SocialLoginButtonsProps> = ({ onSocialLogin }) => {
  return (
    <div className="w-full space-y-2">
      {/* Google Button */}
      <button
        type="button"
        onClick={() => onSocialLogin('google')}
        className="btn w-100 d-flex align-items-center justify-content-center gap-2 mb-2"
        style={{
          backgroundColor: '#ffffff',
          color: '#757575',
          border: '1px solid #dadce0',
          padding: '8px 16px',
          height: '40px'
        }}
      >
        <i className="ri-google-fill fs-16"></i>
        Sign in with Google
      </button>



      {/* Apple Button */}
      {/*
      <button
        type="button"
        onClick={() => onSocialLogin('apple')}
        className="btn w-100 d-flex align-items-center justify-content-center gap-2 mb-2"
        style={{ 
          backgroundColor: '#000000', 
          color: '#ffffff',
          border: 'none',
          padding: '8px 16px',
          height: '40px'
        }}
      >
        <i className="ri-apple-fill fs-16"></i>
        Sign in with Apple
      </button>
        */}
      {/* Facebook Button */}
      {/*
            <button
                type="button"
                onClick={() => onSocialLogin('facebook')}
                className="btn w-100 d-flex align-items-center justify-content-center gap-2 mb-2"
                style={{
                    backgroundColor: '#1877F2',
                    color: '#ffffff',
                    border: 'none',
                    padding: '8px 16px',
                    height: '40px'
                }}
            >
                <i className="ri-facebook-fill fs-16"></i>
                Sign in with Facebook
            </button>
              */}

      {/* Microsoft Button */}
      {/*
      <button
        type="button"
        onClick={() => onSocialLogin('microsoft')}
        className="btn w-100 d-flex align-items-center justify-content-center gap-2"
        style={{ 
          backgroundColor: '#2F2F2F', 
          color: '#ffffff',
          border: 'none',
          padding: '8px 16px',
          height: '40px'
        }}
      >
        <i className="ri-microsoft-fill fs-16"></i>
        Sign in with Microsoft
      </button>
      */}
    </div>
  );
};

export default SocialLoginButtons;